import { CLINICAL_BASE_PATH } from '../constants';

export const BASE_SAMPLE_SEARCH_PATH = `${CLINICAL_BASE_PATH}/sample_search`;
